<template>
    <AppLayoutNoMenu>
        <template #header>
            <div class="flex items-center justify-between">
                <a
                    @click="back"
                    class="rounded-md bg-white px-2.5 py-2 text-sm font-semibold text-iron-900 shadow-sm ring-iron-300 hover:bg-iron-50 inline-flex items-center ring-1 ring-inset"
                >
                    <ArrowLeft :size="16" :stroke-width="2" />

                    <span class="ml-2 sm:inline-block hidden">{{
                        $t("go_back")
                    }}</span>
                </a>

                <Transition mode="out-in">
                    <div v-if="justSaved" class="text-sm text-black">
                        {{ $t("saved") }}
                    </div>
                </Transition>
            </div>
        </template>
        <template #icon>
            <div class="h-10 w-10 flex items-center justify-center">
                <svg
                    width="30"
                    height="30"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                >
                    <path
                        stroke="url(#paint0_linear_68_19)"
                        stroke-width="1.8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_68_19"
                            x1="4.56256"
                            y1="4.33394"
                            x2="24.9101"
                            y2="26.2819"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#FF8D47" />
                            <stop offset="0.147634" stop-color="#FF7447" />
                            <stop offset="0.454086" stop-color="#FF4247" />
                            <stop offset="0.636926" stop-color="#E92A5B" />
                            <stop offset="0.740367" stop-color="#DD1C67" />
                            <stop offset="0.842991" stop-color="#D31071" />
                            <stop offset="1" stop-color="#CF0283" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
        </template>

        <div>
            <EmailWorkflow
                v-if="workflow.action === 'send_email'"
                :workflow="workflow"
                :template="template"
                :email-html-content="emailHtmlContent"
                :attachments="attachments"
                @saved="onSaved"
            ></EmailWorkflow>
        </div>
    </AppLayoutNoMenu>
</template>

<script lang="ts" setup>
import AppLayoutNoMenu from "../../../../Layouts/AppLayoutNoMenu.vue";
import { Button } from "@/components/ui/button";
import type { Workflow } from "./components/Workflow.vue";
import EmailWorkflow from "./components/EmailWorkflow/index.vue";
import type { EmailTemplateAttachmentDTO } from "@/types/EmailTemplateAttachments";
import { ArrowLeft } from "lucide-vue-next";
import { ref } from "vue";

defineProps<{
    workflow: Workflow;
    template: any;
    emailHtmlContent: string;
    attachments?: EmailTemplateAttachmentDTO[];
}>();

function back() {
    window.history.back();
}

const justSaved = ref(false);
let savedTimeout: NodeJS.Timeout | null = null;

function onSaved() {
    justSaved.value = true;

    // Clear any existing timeout to prevent conflicts
    if (savedTimeout) {
        clearTimeout(savedTimeout);
    }

    // Set a new timeout
    savedTimeout = setTimeout(() => {
        justSaved.value = false;
        savedTimeout = null;
    }, 3000);
}
</script>
